"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TotalizerLabel = function TotalizerLabel(_ref) {
  var label = _ref.label,
      mobileScroll = _ref.mobileScroll;
  return _react2.default.createElement("div", {
    "data-testid": "totalizer-label",
    className: (0, _classnames2.default)('c-muted-2 f6', {
      nowrap: mobileScroll
    })
  }, label);
};

TotalizerLabel.propTypes = {
  label: _propTypes2.default.string.isRequired,
  mobileScroll: _propTypes2.default.bool
};
exports.default = TotalizerLabel;